const collectionId = 'liberty';
const milleage = 'Liberté';

module.exports = [
  {
    id: 'silver-50',
    label: 'Monnaie de <b>50 euros Argent</b>',
    value: 50,
    sellPrice: 55,
    state: 2,
    price: '50,00 €',
    collection: collectionId,
    wave: 3,
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Argent 900‰' },
      { label: 'Poids', value: '16 g' },
      { label: 'Diamètre', value: 'Ø 33' },
      { label: 'Exemplaires', value: '75 000' },
    ],
    // subscription: {
    //   startDate: '2026-05-05',
    //   endDate: '2026-06-04',
    // },
  },
  {
    id: 'silver-100',
    label: 'Monnaie de <b>100 euros Argent</b>',
    value: 100,
    sellPrice: 115,
    state: 0,
    price: '100,00 €',
    collection: collectionId,
    wave: 1,
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Argent 900‰' },
      { label: 'Poids', value: '45 g' },
      { label: 'Diamètre', value: 'Ø 47' },
      { label: 'Exemplaires', value: '10 000' },
    ],
  },
  {
    id: 'gold-250',
    label: 'Monnaie de <b>250 euros Or</b>',
    value: 250,
    sellPrice: 285,
    state: 1,
    price: '250,00 €',
    collection: collectionId,
    wave: 1,
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Or 999‰' },
      { label: 'Qualité', value: 'Brillant Universel' },
      { label: 'Poids', value: '1,75 g' },
      { label: 'Diamètre', value: 'Ø 13' },
      { label: 'Exemplaires', value: '15 000' },
    ],
  },
  {
    id: 'gold-1000',
    label: 'Monnaie de <b>1 000 euros Or</b>',
    value: 1000,
    sellPrice: 1090,
    state: 3,
    price: '1000,00 €',
    collection: collectionId,
    wave: 2,
    subscription: {
      startDate: '2026-03-10',
      endDate: '2026-04-09',
    },
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Or 999‰' },
      { label: 'Qualité', value: 'Brillant Universel' },
      { label: 'Poids', value: '6,5 g' },
      { label: 'Diamètre', value: 'Ø 23' },
      { label: 'Exemplaires', value: '6 000' },
    ],
  },
  {
    id: 'gold-2500',
    label: 'Monnaie de <b>2 500 euros Or</b>',
    value: 2500,
    sellPrice: 2750,
    state: 0,
    price: '2500,00 €',
    collection: collectionId,
    wave: 3,
    subscription: {
      startDate: '2026-05-05',
      endDate: '2026-06-04',
    },
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Or 999‰' },
      { label: 'Qualité', value: 'Brillant Universel' },
      { label: 'Poids', value: '16,25 g' },
      { label: 'Diamètre', value: 'Ø 33' },
      { label: 'Exemplaires', value: '2 000' },
    ],
  },
  {
    id: 'gold-5000',
    label: 'Monnaie de <b>5 000 euros Or</b>',
    value: 5000,
    sellPrice: 5250,
    state: 0,
    price: '5000,00 €',
    collection: collectionId,
    wave: 4,
    // subscription: {
    //   startDate: '2026-09-08',
    //   endDate: '2026-10-08',
    // },
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Or 999‰' },
      { label: 'Qualité', value: 'Brillant Universel' },
      { label: 'Poids', value: '26 g' },
      { label: 'Diamètre', value: 'Ø 37' },
      { label: 'Exemplaires', value: '1 200' },
    ],
  },
  {
    id: 'gold-10000',
    label: 'Monnaie de <b>10 000 euros Or</b>',
    value: 10000,
    sellPrice: 10500,
    state: 0,
    price: '10000,00 €',
    collection: collectionId,
    wave: 5,
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Or 999‰' },
      { label: 'Qualité', value: 'Brillant Universel' },
      { label: 'Poids', value: '50 g' },
      { label: 'Diamètre', value: 'Ø 45' },
      { label: 'Exemplaires', value: '200' },
    ],
    // subscription: {
    //   startDate: '2026-12-02',
    //   endDate: '2027-01-01',
    // },
  },
];
